import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Input,
  Label,
  Button,
  FormGroup,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import swal from "sweetalert";
import { FaUpload } from "react-icons/fa";
import { MdCancel, MdDelete } from "react-icons/md";
import * as XLSX from "xlsx";

import {
  CreateCustomerUpdate,
  CreateCustomersave,
  Get_RoleList,
  _Get,
  _PostSave,
  _GetByUrlOnly,
  DeleteCustomerList,
} from "../import/ApiEndPoint/ApiCalling";

import {
  Create_Transporter_List,
  GST_Verification_Api,
  Image_URL,
  Pan_Verification_API,
  Pan_Verification_key,
  View_CustomerGroup,
  View_Customer_ById,
  country_state_City_List,
  Deptartment_with_Role,
  All_Users_List,
  User_Assign_User,
  viewpincodedata,
  viewpincodedata1,
} from "../import/ApiEndPoint/Api";

const injectOnce = () => {
  if (document.getElementById("create-customer-two-col-css")) return;

  const s = document.createElement("style");
  s.id = "create-customer-two-col-css";
  s.textContent = `
    .cc-wrap { gap: 12px; }
    .cc-card{ border-radius:14px; border:1px solid #e5e7eb; overflow:hidden; }
    .cc-h1{ font-weight:800; text-transform:uppercase; font-size:18px; }
    .cc-sub{ font-weight:700; font-size:16px; }
    .cc-file { display:grid; place-items:center; border:1px dashed #9ca3af; padding:16px; border-radius:12px; background:#f9fafb; }
    .cc-grid-2{ display:grid; grid-template-columns:1fr 1fr; gap:16px; }
    .cc-col{ display:flex; flex-direction:column; gap:16px; }
    .cc-section{ border:1px solid #f0f0f0; border-radius:12px; padding:12px; }

    .cc-bulk-simple-card{
      background:#fff;
      border:1px solid #e5e7eb;
      border-radius:10px;
      padding:12px 14px;
      margin-bottom:10px;
      box-shadow:0 2px 8px rgba(0,0,0,.08);
    }
    .cc-bulk-simple-head{
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:12px;
      cursor:pointer;
    }
    .cc-bulk-simple-title{
      font-weight:700;
      font-size:14px;
    }
    .cc-bulk-cross{
      border:none;
      background:transparent;
      font-size:22px;
      line-height:1;
      cursor:pointer;
      padding:0 4px;
    }
    .cc-bulk-simple-body{
      margin-top:12px;
      padding-top:12px;
      border-top:1px solid #e5e7eb;
    }
    .cc-bulk-error{
      font-size:12px;
      margin-top:6px;
      color:#111827;
    }

    @media(max-width: 900px){
      .cc-grid-2{ grid-template-columns:1fr; }
    }
  `;
  document.head.appendChild(s);
};

const toStr = (v) => (v === null || v === undefined ? "" : String(v));

const safeText = (v) => {
  if (typeof v === "string" || typeof v === "number") return String(v);

  if (v && typeof v === "object") {
    return (
      toStr(v?.departmentName) ||
      toStr(v?.DepartmentName) ||
      toStr(v?.name) ||
      toStr(v?.roleName) ||
      toStr(v?._id) ||
      ""
    );
  }

  return "";
};

const getSuperGST = () => {
  try {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const db = user?.database;

    const raw =
      (user?.Gst_No && String(user.Gst_No)) ||
      (user?.CompanyDetails?.Gst_No && String(user.CompanyDetails.Gst_No)) ||
      "";

    if (raw) return raw.toUpperCase();
    if (String(db) === "2405") return "20";

    return "";
  } catch {
    return "";
  }
};

const getGSTPrefix = (gst) => {
  if (!gst) return "";
  return String(gst).toUpperCase().trim().slice(0, 2);
};

const inferRegionType = (superGST, partyGST) => {
  const s = getGSTPrefix(superGST);
  const p = getGSTPrefix(partyGST);

  if (s && p) return s === p ? "Local" : "Outside";

  return "Local";
};

const normalizeOpeningFinancialYear = (value) => {
  const raw = String(value || "").trim();

  const match = raw.match(/^(\d{4})\s*-\s*(\d{2}|\d{4})$/);
  if (!match) return raw;

  const startYear = match[1];
  const endYear = match[2].length === 4 ? match[2].slice(-2) : match[2];

  return `${startYear}-${endYear}`;
};

const getFYStartYear = (date = new Date()) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth();

  return m >= 3 ? y : y - 1;
};

const getCurrentOpeningFinancialYear = () => {
  const start = getFYStartYear(new Date());
  return normalizeOpeningFinancialYear(`${start}-${start + 1}`);
};

const buildOpeningFinancialYearOptions = (past = 5, future = 2) => {
  const currentStart = getFYStartYear(new Date());
  const arr = [];

  for (let y = currentStart - past; y <= currentStart + future; y++) {
    arr.push(normalizeOpeningFinancialYear(`${y}-${y + 1}`));
  }

  return arr.reverse();
};

const isSalesPersonRole = (roleName) => {
  const rn = (roleName || "").toLowerCase().replace(/\s+/g, "");
  return rn.includes("sales") && rn.includes("person");
};

const getAssignedParentId = (createdBy) => {
  if (!createdBy) return "";

  if (typeof createdBy === "object") {
    return toStr(createdBy?._id || createdBy?.id);
  }

  return toStr(createdBy);
};

const getAssignedParentUser = (customerData, users = []) => {
  const parentId = getAssignedParentId(customerData?.created_by);
  if (!parentId) return null;

  const fromUserList =
    (Array.isArray(users) ? users : []).find(
      (user) => String(user?._id) === String(parentId),
    ) || null;

  if (fromUserList) return fromUserList;

  if (customerData?.created_by && typeof customerData.created_by === "object") {
    return customerData.created_by;
  }

  return null;
};

const makeDefaultCustomerForm = () => ({
  bankDetails: [{ Account_Name: "", Account_No: "", Ifsc_code: "" }],
  paymentTerm: "N/A",
  partyType: "N/A",
  status: "Active",
  regionType: "Local",
  registrationType: "UnKnown",
  openingFinancialYear: getCurrentOpeningFinancialYear(),
  transporterDetail: 0,
  assignTransporter: [],
});

const normalizeKey = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const cleanCell = (v) => {
  if (v === null || v === undefined) return "";
  return String(v).trim();
};

const cleanDigits = (v) => cleanCell(v).replace(/[^\d]/g, "");

const maybeNumber = (v) => {
  const raw = cleanCell(v);
  if (!raw) return "";

  const n = Number(String(raw).replace(/,/g, ""));
  return Number.isFinite(n) ? n : raw;
};

const getCell = (row, aliases = []) => {
  const map = {};

  Object.entries(row || {}).forEach(([k, v]) => {
    map[normalizeKey(k)] = v;
  });

  for (const alias of aliases) {
    const key = normalizeKey(alias);

    if (Object.prototype.hasOwnProperty.call(map, key)) {
      return map[key];
    }
  }

  return "";
};

const customerFieldAliases = {
  CompanyName: ["CompanyName", "Company Name", "company", "companyName"],
  gstNumber: ["gstNumber", "GST Number", "GST", "gstNo", "gst"],
  comPanNo: ["comPanNo", "Company PAN", "PAN", "panNumber", "panNo"],
  mobileNumber: ["mobileNumber", "Mobile Number", "mobile", "phone"],
  address: ["address", "Address", "Registered Address"],
  partyType: ["partyType", "Party Type"],
  registrationType: ["registrationType", "Registration Type"],
  limit: ["limit", "Amount Limit", "creditLimit"],
  lockInTime: ["lockInTime", "Credit Period", "Credit Period Days"],
  paymentTerm: ["paymentTerm", "Payment Term"],
  pincode: ["pincode", "Pin Code", "PIN", "pin"],
  email: ["email", "Email"],
  ownerName: ["ownerName", "Owner Name"],
  aadharNo: ["aadharNo", "Aadhar Number", "Aadhaar Number", "aadhaarNo"],
  ownerAddress: ["ownerAddress", "Owner Address"],
  contactNumber: ["contactNumber", "Owner Number", "Contact Number"],
  serviceArea: ["serviceArea", "Service Area"],

  OpeningBalance: ["OpeningBalance", "Opening Balance", "opening balance"],
  openingFinancialYear: [
    "openingFinancialYear",
    "Opening Financial Year",
    "FY",
    "Financial Year",
  ],
  Type: ["Type", "Balance Type", "O/P Balance Type", "OP Balance Type"],

  password: ["password", "Password"],
  City: ["City", "city"],
  State: ["State", "state"],
  dealsInProducts: ["dealsInProducts", "Deals in Product", "Deals In Products"],
  annualTurnover: ["annualTurnover", "Annual Turnover"],
  shopSize: ["shopSize", "Shop Size"],
  Account_Name: ["Account_Name", "Bank Name", "Account Name"],
  Account_No: ["Account_No", "Account Number"],
  Ifsc_code: ["Ifsc_code", "IFSC", "IFSC Code"],
};

const isEmptyExcelRow = (row) => {
  return !Object.values(row || {}).some((v) => cleanCell(v) !== "");
};

const readFileWithReader = (file, type) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;

    if (type === "text") reader.readAsText(file);
    else reader.readAsArrayBuffer(file);
  });

const readBulkFileRows = async (file) => {
  const name = String(file?.name || "").toLowerCase();
  const isCsv = name.endsWith(".csv");

  const data = isCsv
    ? await readFileWithReader(file, "text")
    : await readFileWithReader(file, "array");

  const workbook = XLSX.read(data, {
    type: isCsv ? "string" : "array",
    cellDates: false,
    raw: false,
  });

  const sheetName = workbook.SheetNames?.[0];
  if (!sheetName) return [];

  const sheet = workbook.Sheets[sheetName];

  return XLSX.utils.sheet_to_json(sheet, {
    defval: "",
    raw: false,
  });
};

const normalizeExcelCustomerRow = (row, index, baseForm = {}) => {
  const superGST = getSuperGST();

  const gst = cleanCell(
    getCell(row, customerFieldAliases.gstNumber),
  ).toUpperCase();

  const panFromFile = cleanCell(
    getCell(row, customerFieldAliases.comPanNo),
  ).toUpperCase();

  const panFromGst = gst && gst.length >= 12 ? gst.slice(2, 12) : "";
  const comPanNo = panFromFile || panFromGst;

  const mobileRaw = getCell(row, customerFieldAliases.mobileNumber);
  const aadharNo = cleanDigits(
    getCell(row, customerFieldAliases.aadharNo),
  ).slice(0, 12);

  const pincode = cleanDigits(getCell(row, customerFieldAliases.pincode)).slice(
    0,
    6,
  );

  const Account_Name = cleanCell(
    getCell(row, customerFieldAliases.Account_Name),
  );

  const Account_No = cleanCell(getCell(row, customerFieldAliases.Account_No));

  const Ifsc_code = cleanCell(
    getCell(row, customerFieldAliases.Ifsc_code),
  ).toUpperCase();

  const hasBank = Account_Name || Account_No || Ifsc_code;

  const passwordFromFile = cleanCell(
    getCell(row, customerFieldAliases.password),
  );

  const mobileDigits = cleanDigits(mobileRaw);

  const fallbackPassword =
    passwordFromFile || comPanNo || aadharNo || mobileDigits || "123456";

  const registrationType =
    cleanCell(getCell(row, customerFieldAliases.registrationType)) ||
    (gst ? "Regular" : "UnKnown");

  const openingFY =
    normalizeOpeningFinancialYear(
      cleanCell(getCell(row, customerFieldAliases.openingFinancialYear)),
    ) || getCurrentOpeningFinancialYear();

  return {
    ...makeDefaultCustomerForm(),

    rolename: baseForm?.rolename || "",
    roleName: baseForm?.roleName || "",

    CompanyName: cleanCell(getCell(row, customerFieldAliases.CompanyName)),
    gstNumber: gst,
    comPanNo,
    mobileNumber: maybeNumber(mobileRaw),
    address: cleanCell(getCell(row, customerFieldAliases.address)),
    partyType: cleanCell(getCell(row, customerFieldAliases.partyType)) || "N/A",
    registrationType,
    limit: maybeNumber(getCell(row, customerFieldAliases.limit)),
    lockInTime: maybeNumber(getCell(row, customerFieldAliases.lockInTime)),
    paymentTerm:
      cleanCell(getCell(row, customerFieldAliases.paymentTerm)) || "N/A",
    pincode,
    email: cleanCell(getCell(row, customerFieldAliases.email)),
    ownerName: cleanCell(getCell(row, customerFieldAliases.ownerName)),
    aadharNo,
    ownerAddress: cleanCell(getCell(row, customerFieldAliases.ownerAddress)),
    contactNumber: maybeNumber(
      getCell(row, customerFieldAliases.contactNumber),
    ),
    serviceArea: cleanCell(getCell(row, customerFieldAliases.serviceArea)),

    OpeningBalance: maybeNumber(
      getCell(row, customerFieldAliases.OpeningBalance),
    ),
    openingFinancialYear: openingFY || getCurrentOpeningFinancialYear(),
    Type: cleanCell(getCell(row, customerFieldAliases.Type)),

    City: cleanCell(getCell(row, customerFieldAliases.City)),
    State: cleanCell(getCell(row, customerFieldAliases.State)),
    dealsInProducts: cleanCell(
      getCell(row, customerFieldAliases.dealsInProducts),
    ),
    annualTurnover: maybeNumber(
      getCell(row, customerFieldAliases.annualTurnover),
    ),
    shopSize: cleanCell(getCell(row, customerFieldAliases.shopSize)),
    password: fallbackPassword,

    bankDetails: hasBank
      ? [{ Account_Name, Account_No, Ifsc_code }]
      : [{ Account_Name: "", Account_No: "", Ifsc_code: "" }],

    regionType: inferRegionType(superGST, gst),
    status: "Active",

    _bulkRowNo: index + 1,
    _cityOptions: [],
    _showCityDropdown: false,

    _autoAssign: false,
    _assignDropdown: [],
    _selectedSalesPerson: null,
  };
};

const CreateCustomerTwoColumnHybrid = () => {
  injectOnce();

  const navigate = useNavigate();
  const location = useLocation();
  const Params = useParams();
  const isCreate = String(Params?.id) === "0";

  // Special mode used only when SuperAdmin opens a Waiting conversion
  // from Sales Lead -> Requested -> Conversion Requests -> Edit.
  // It reuses this existing customer edit page and the SAME Mongo document.
  const isConversionEdit =
    !isCreate &&
    (location?.state?.conversionEdit === true ||
      new URLSearchParams(location?.search || "").get("conversionEdit") ===
        "1");

  const openingFYOptions = useMemo(
    () => buildOpeningFinancialYearOptions(5, 2),
    [],
  );

  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState("");

  const [bulkMode, setBulkMode] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkCustomers, setBulkCustomers] = useState([]);
  const [expandedBulkIndex, setExpandedBulkIndex] = useState(null);
  const [activeBulkIndex, setActiveBulkIndex] = useState(-1);
  const [bulkSavingIndex, setBulkSavingIndex] = useState(null);
  const [bulkSaveAllLoading, setBulkSaveAllLoading] = useState(false);

  const [pincodeLoading, setPincodeLoading] = useState(false);

  const [formData, setFormData] = useState(makeDefaultCustomerForm());

  const [customerGroups, setCustomerGroups] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [pinCodeList, setPinCodeList] = useState([]);
  const [allTransporter, setAllTransporter] = useState([]);
  const [countryCityList, setCountryCityList] = useState([]);

  const [cityOptions, setCityOptions] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  const [deptWithRole, setDeptWithRole] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const [profileFile, setProfileFile] = useState(null);
  const [profilePreview, setProfilePreview] = useState("");
  const [shopFiles, setShopFiles] = useState([]);
  const [shopPreviews, setShopPreviews] = useState([]);
  const [removedShopPhotos, setRemovedShopPhotos] = useState([]);

  const [autoAssign, setAutoAssign] = useState(false);
  const [assignDropdown, setAssignDropdown] = useState([]);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
  const [manualAssignOpen, setManualAssignOpen] = useState(false);
  const [assignedTo, setAssignedTo] = useState(null);
  const [pendingAssignPincode, setPendingAssignPincode] = useState("");

  const pinReqRef = useRef(0);

  const getSalespeopleForPincode = (pincode6, users = allUsers) => {
    const pin = String(pincode6 || "").trim();
    const list = Array.isArray(users) ? users : [];

    if (!pin || pin.length !== 6) return [];

    return list.filter((u) => {
      const roleName = u?.rolename?.roleName || u?.rolename?.name || "";
      const okRole = isSalesPersonRole(roleName);
      const okStatus = String(u?.status || "").toLowerCase() === "active";

      const okService =
        Array.isArray(u?.service) &&
        u.service.some((s) => String(s?.pincode) === String(pin));

      return okRole && okStatus && okService;
    });
  };

  const applySalespersonByPincodeToData = (data, users = allUsers) => {
    const pin = String(data?.pincode || "").trim();
    const filtered = getSalespeopleForPincode(pin, users);

    // In edit mode, created_by is the assignment used by AssignTeamMember.
    // It can be a populated user object or only the assigned user's ID.
    const assignedPerson = getAssignedParentUser(data, users);
    const oldSelected = data?._selectedSalesPerson || null;
    const options = [...filtered];

    // Keep the currently assigned salesperson visible and selected even if
    // their service-area pincodes were changed after the customer was assigned.
    if (
      assignedPerson?._id &&
      !options.some(
        (person) => String(person?._id) === String(assignedPerson?._id),
      )
    ) {
      options.unshift(assignedPerson);
    }

    const selected = assignedPerson?._id
      ? assignedPerson
      : oldSelected?._id &&
          options.some(
            (person) => String(person?._id) === String(oldSelected?._id),
          )
        ? oldSelected
        : options[0] || null;

    if (options.length) {
      return {
        ...data,
        _autoAssign: true,
        _assignDropdown: options,
        _selectedSalesPerson: selected,
      };
    }

    return {
      ...data,
      _autoAssign: false,
      _assignDropdown: [],
      _selectedSalesPerson: null,
    };
  };

  const setAssignStateFromData = (data) => {
    const enhanced = applySalespersonByPincodeToData(data || {}, allUsers);
    const list = enhanced?._assignDropdown || [];
    const selected = enhanced?._selectedSalesPerson || null;

    if (list.length) {
      setAutoAssign(true);
      setAssignDropdown(list);
      setSelectedSalesPerson(selected || list[0]);
      setManualAssignOpen(false);
      setAssignedTo(null);
    } else {
      setAutoAssign(false);
      setAssignDropdown([]);
      setSelectedSalesPerson(null);
      setManualAssignOpen(false);
    }

    return enhanced;
  };

  const resetTransientRowStates = () => {
    setProfileFile(null);
    setProfilePreview("");
    setShopFiles([]);
    setShopPreviews([]);
    setRemovedShopPhotos([]);
    setAutoAssign(false);
    setAssignDropdown([]);
    setSelectedSalesPerson(null);
    setManualAssignOpen(false);
    setAssignedTo(null);
    setSelectedDept("");
    setSelectedRole("");
    setPendingAssignPincode("");
    setCityOptions([]);
    setShowCityDropdown(false);
  };

  const getTransportersForCity = (cityValue) => {
    const city = toStr(cityValue).toLowerCase().trim();
    const list = Array.isArray(allTransporter) ? allTransporter : [];

    if (!city) return [];

    return list.filter((t) => {
      const a = toStr(t?.City).toLowerCase();
      const b = toStr(t?.city).toLowerCase();
      const c = toStr(t?.District).toLowerCase();
      const d = toStr(t?.district).toLowerCase();
      const e = toStr(t?.serviceArea).toLowerCase();

      return (
        a === city ||
        b === city ||
        c === city ||
        d === city ||
        a.includes(city) ||
        b.includes(city) ||
        c.includes(city) ||
        d.includes(city) ||
        e.includes(city)
      );
    });
  };

  const applyTransporterByCityToData = (data, cityValue) => {
    const found = getTransportersForCity(cityValue || data?.City);

    if (found.length) {
      return {
        ...data,
        transporterDetail: 1,
        assignTransporter: [found[0]],
      };
    }

    return {
      ...data,
      transporterDetail: 0,
      assignTransporter: [],
    };
  };

  const resolveCityStateByPincodeForData = async (data) => {
    const pin = cleanDigits(data?.pincode).slice(0, 6);

    if (!pin || pin.length !== 6) {
      const withTransporter = applyTransporterByCityToData(data, data?.City);
      return applySalespersonByPincodeToData(withTransporter, allUsers);
    }

    try {
      const url = `${viewpincodedata1}?pincode=${pin}`;
      const res = await _GetByUrlOnly(url);
      const list = Array.isArray(res?.pinCodes) ? res.pinCodes : [];

      if (res?.status && list.length) {
        const excelCity = toStr(data?.City);

        const existingMatch =
          list.find(
            (x) => toStr(x?.city).toLowerCase() === excelCity.toLowerCase(),
          ) || null;

        const selected = existingMatch || list[0];

        const updated = {
          ...data,
          pincode: pin,
          City: toStr(selected?.city),
          State: toStr(selected?.state),
          _cityOptions: list,
          _showCityDropdown: list.length > 1,
        };

        const withTransporter = applyTransporterByCityToData(
          updated,
          updated.City,
        );

        return applySalespersonByPincodeToData(withTransporter, allUsers);
      }
    } catch {}

    let match = pinCodeList.find((x) => String(x?.pincode) === pin);

    if (!match && Array.isArray(countryCityList) && countryCityList.length) {
      match =
        countryCityList.find((x) => String(x?.pincode) === pin) ||
        countryCityList.find((x) => String(x?.pinCode) === pin) ||
        null;
    }

    if (match) {
      const city =
        match.city || match.City || match.district || match.District || "";
      const state = match.state || match.State || "";

      const updated = {
        ...data,
        pincode: pin,
        City: city,
        State: state,
        _cityOptions: [],
        _showCityDropdown: false,
      };

      const withTransporter = applyTransporterByCityToData(updated, city);

      return applySalespersonByPincodeToData(withTransporter, allUsers);
    }

    const withTransporter = applyTransporterByCityToData(data, data?.City);
    return applySalespersonByPincodeToData(withTransporter, allUsers);
  };

  // Reload the saved pincode in edit mode so the multiple-city dropdown is
  // available exactly as it is while creating a customer.
  const hydrateExistingCustomerLocation = async (customerData) => {
    const pin = cleanDigits(customerData?.pincode).slice(0, 6);

    if (pin.length !== 6) {
      return {
        data: customerData,
        options: [],
        showDropdown: false,
      };
    }

    try {
      const response = await _GetByUrlOnly(
        `${viewpincodedata1}?pincode=${pin}`,
      );

      const options = Array.isArray(response?.pinCodes)
        ? response.pinCodes
        : [];

      if (!options.length) {
        return {
          data: customerData,
          options: [],
          showDropdown: false,
        };
      }

      const savedCity = toStr(customerData?.City).trim().toLowerCase();

      const savedCityOption =
        options.find(
          (option) => toStr(option?.city).trim().toLowerCase() === savedCity,
        ) || null;

      const selectedOption = savedCityOption || options[0];

      return {
        data: {
          ...customerData,
          pincode: pin,
          City: toStr(selectedOption?.city) || toStr(customerData?.City),
          State: toStr(selectedOption?.state) || toStr(customerData?.State),
          _cityOptions: options,
          _showCityDropdown: options.length > 1,
        },
        options,
        showDropdown: options.length > 1,
      };
    } catch {
      return {
        data: customerData,
        options: [],
        showDropdown: false,
      };
    }
  };

  useEffect(() => {
    if (!bulkMode) return;
    if (activeBulkIndex < 0) return;
    if (!bulkCustomers?.[activeBulkIndex]) return;

    setBulkCustomers((prev) => {
      const next = [...prev];

      const oldData = next[activeBulkIndex]?.data || {};
      const updatedForm = {
        ...formData,
        _autoAssign: autoAssign,
        _assignDropdown: assignDropdown,
        _selectedSalesPerson: selectedSalesPerson,
      };

      const oldText = JSON.stringify(oldData);
      const newText = JSON.stringify(updatedForm);

      if (oldText === newText) return prev;

      next[activeBulkIndex] = {
        ...next[activeBulkIndex],
        data: updatedForm,
      };

      return next;
    });
  }, [
    formData,
    autoAssign,
    assignDropdown,
    selectedSalesPerson,
    bulkMode,
    activeBulkIndex,
  ]);

  useEffect(() => {
    if (!bulkMode) return;
    if (!Array.isArray(allUsers) || !allUsers.length) return;
    if (!bulkCustomers.length) return;

    setBulkCustomers((prev) =>
      prev.map((item) => ({
        ...item,
        data: applySalespersonByPincodeToData(item.data || {}, allUsers),
      })),
    );

    if (activeBulkIndex >= 0 && bulkCustomers?.[activeBulkIndex]?.data) {
      const updated = applySalespersonByPincodeToData(
        bulkCustomers[activeBulkIndex].data,
        allUsers,
      );

      setFormData(updated);
      setAssignStateFromData(updated);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allUsers, bulkMode]);

  useEffect(() => {
    try {
      if (!isCreate) return;
      if (bulkMode) return;
      if (formData?.geotagging) return;
      if (!navigator?.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos?.coords?.latitude;
          const lng = pos?.coords?.longitude;

          if (lat && lng) {
            setFormData((p) => ({ ...p, geotagging: `${lat},${lng}` }));
          }
        },
        () => {},
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 },
      );
    } catch {}
  }, [isCreate, bulkMode, formData?.geotagging]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        try {
          const pRes = await _GetByUrlOnly(viewpincodedata);
          const uniquePins = Array.isArray(pRes?.pinCodeList)
            ? pRes.pinCodeList
            : [];
          setPinCodeList(uniquePins);
        } catch {
          setPinCodeList([]);
        }

        try {
          const cs = await _GetByUrlOnly(country_state_City_List);
          const list =
            cs?.country_state_City_List ||
            cs?.countryCityList ||
            cs?.data ||
            cs?.list ||
            cs?.CountryStateCityList ||
            [];

          if (Array.isArray(list)) setCountryCityList(list);
        } catch {}

        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const db = userData?.database;

        const usersRes = await _Get(All_Users_List, db);
        const loadedUsers = Array.isArray(usersRes?.User) ? usersRes.User : [];
        setAllUsers(loadedUsers);

        try {
          const dwr = await _Get(Deptartment_with_Role, db);
          const raw =
            dwr?.DepartmentWithRole ||
            dwr?.Deptartment_with_Role ||
            dwr?.Department ||
            dwr?.Departments ||
            dwr?.data ||
            dwr?.list ||
            [];

          if (Array.isArray(raw)) setDeptWithRole(raw);
        } catch {}

        if (isCreate) {
          const r = await Get_RoleList(userData?._id, db);
          const roles = Array.isArray(r?.Role) ? r.Role : [];
          const customerRole = roles.find((rr) =>
            toStr(rr?.roleName).toLowerCase().includes("customer"),
          );

          if (customerRole) {
            setFormData((prev) => ({
              ...prev,
              rolename: customerRole?._id,
              roleName: customerRole?.roleName,
            }));
          }
        }

        const cg = await _Get(View_CustomerGroup, db);
        const activeGroups = (cg?.CustomerGroup || []).filter(
          (g) => g?.status === "Active",
        );
        setCustomerGroups(activeGroups);

        const t = await _Get(Create_Transporter_List, db);
        setAllTransporter(Array.isArray(t?.Transporter) ? t.Transporter : []);

        if (!isCreate) {
          const res = await _Get(View_Customer_ById, Params?.id);
          const value = res?.Customer || {};
          let next = { ...value };

          next.rolename = value?.rolename?._id || value?.rolename;
          if (value?.category?._id) next.category = value?.category?._id;

          next.openingFinancialYear = normalizeOpeningFinancialYear(
            value?.openingFinancialYear || getCurrentOpeningFinancialYear(),
          );

          const superGST = getSuperGST();
          next.regionType =
            value?.regionType ||
            inferRegionType(superGST, value?.gstNumber || "");

          // FIX 1: fetch all cities for the saved pincode in edit mode.
          const locationResult = await hydrateExistingCustomerLocation(next);
          next = locationResult.data;

          setCityOptions(locationResult.options);
          setShowCityDropdown(locationResult.showDropdown);

          // FIX 2: resolve created_by and preselect the assigned salesperson.
          const assignmentReadyData = applySalespersonByPincodeToData(
            next,
            loadedUsers,
          );

          setFormData(assignmentReadyData);
          setAutoAssign(
            Array.isArray(assignmentReadyData?._assignDropdown) &&
              assignmentReadyData._assignDropdown.length > 0,
          );
          setAssignDropdown(assignmentReadyData?._assignDropdown || []);
          setSelectedSalesPerson(
            assignmentReadyData?._selectedSalesPerson || null,
          );
          setManualAssignOpen(false);
          setAssignedTo(null);

          if (value?.Photo) {
            setProfilePreview(`${Image_URL}/Images/${value.Photo}`);
          }

          if (Array.isArray(value?.shopPhoto)) {
            setShopPreviews(
              value.shopPhoto.map((fn) => `${Image_URL}/Images/${fn}`),
            );
          }
        } else {
          setFormData((p) => ({
            ...p,
            regionType: p?.regionType || "Local",
            openingFinancialYear:
              p?.openingFinancialYear || getCurrentOpeningFinancialYear(),
          }));

          setShowCityDropdown(false);
          setCityOptions([]);
        }
      } catch {
      } finally {
        setLoading(false);
      }
    })();
  }, [Params?.id, isCreate]);

  const verifyCompanyPAN = async (pan) => {
    try {
      const payload = { api_key: Pan_Verification_key, pan };
      const res = await _PostSave(Pan_Verification_API, payload);

      if (res?.flag) {
        setFormData((p) => ({ ...p, comPanNo: pan, IsValid_comPanNo: true }));
        swal("Success", "PAN verified with GST", "success");
      } else {
        setFormData((p) => ({ ...p, comPanNo: pan, IsValid_comPanNo: false }));
      }
    } catch {
      setFormData((p) => ({ ...p, comPanNo: pan, IsValid_comPanNo: false }));
    }
  };

  const handleGSTChange = async (rawGST) => {
    const v = (rawGST || "").toUpperCase();

    setFormData((p) => ({ ...p, gstNumber: v }));

    if (v.length >= 2) {
      const superGST = getSuperGST();
      const inferred = inferRegionType(superGST, v);
      setFormData((p) => ({ ...p, regionType: inferred }));
    }

    if (v.length === 15) {
      setLoaderText("Getting GST information...");
      setLoading(true);

      try {
        const res = await _Get(GST_Verification_Api, v);
        const adr = toStr(res?.data?.pradr?.adr || "");
        const parts = adr.split(",");
        const part1 = parts[0]?.trim() || "";
        const part2 = parts.slice(1).join(",").trim();
        const derivedPAN = v.slice(2, 12) || "";

        if (res?.flag) {
          setFormData((p) => ({
            ...p,
            CompanyName: res?.data?.tradeNam || p.CompanyName,
            address1: part1,
            address2: part2,
            address: adr || p.address,
            gstNumber: v,
            comPanNo: derivedPAN || p.comPanNo,
          }));
        } else {
          setFormData((p) => ({
            ...p,
            gstNumber: v,
            comPanNo: derivedPAN,
          }));
        }

        if (derivedPAN && derivedPAN.length === 10) {
          verifyCompanyPAN(derivedPAN);
        }
      } catch {
        const derivedPAN = v.slice(2, 12) || "";
        setFormData((p) => ({ ...p, gstNumber: v, comPanNo: derivedPAN }));

        if (derivedPAN && derivedPAN.length === 10) {
          verifyCompanyPAN(derivedPAN);
        }
      } finally {
        setLoading(false);
        setLoaderText("");
      }
    }
  };

  const handleRegionTypeChange = async (e) => {
    const chosen = e.target.value;
    const superGST = getSuperGST();
    const inferred = inferRegionType(superGST, formData?.gstNumber || "");

    if (formData?.gstNumber && chosen !== inferred) {
      const prefixS = getGSTPrefix(superGST) || "??";
      const prefixP = getGSTPrefix(formData?.gstNumber) || "??";
      const want =
        inferred === "Local"
          ? "GST prefixes match, so it looks Local."
          : "GST prefixes differ, so it looks Outside.";

      const ok = await swal({
        title: "Region mismatch",
        text: `SuperAdmin GST: ${prefixS} — Party GST: ${prefixP}\n${want}\nDo you still want to set region as ${chosen}?`,
        icon: "warning",
        buttons: ["No, keep suggested", "Yes, override"],
        dangerMode: true,
      });

      if (ok) setFormData((p) => ({ ...p, regionType: chosen }));
      else setFormData((p) => ({ ...p, regionType: inferred }));
    } else {
      setFormData((p) => ({ ...p, regionType: chosen }));
    }
  };

  const handleInput = (e, type = "text", bankIndex) => {
    const { name, value, files } = e.target;

    const updateBank = (fieldValue) => {
      setFormData((prev) => {
        const oldBank =
          Array.isArray(prev.bankDetails) && prev.bankDetails.length
            ? prev.bankDetails
            : [{ Account_Name: "", Account_No: "", Ifsc_code: "" }];

        return {
          ...prev,
          bankDetails: oldBank.map((b, i) =>
            i === bankIndex ? { ...b, [name]: fieldValue } : b,
          ),
        };
      });
    };

    if (type === "file") {
      if (bankIndex !== undefined) updateBank(files?.[0] || null);
      else setFormData((p) => ({ ...p, [name]: files?.[0] || null }));
      return;
    }

    if (bankIndex !== undefined) updateBank(value);
    else setFormData((p) => ({ ...p, [name]: value }));
  };

  const addBank = () =>
    setFormData((p) => ({
      ...p,
      bankDetails: [
        ...(Array.isArray(p.bankDetails) ? p.bankDetails : []),
        { Account_Name: "", Account_No: "", Ifsc_code: "" },
      ],
    }));

  const removeBank = (i) =>
    setFormData((p) => ({
      ...p,
      bankDetails: (p.bankDetails || []).filter((_, idx) => idx !== i),
    }));

  const handleProfileFile = (file) => {
    if (!file) return;

    const sizeMB = file.size / (1024 * 1024);
    if (sizeMB > 1) return swal("Error", "File size must be ≤ 1MB", "error");

    setProfileFile(file);

    const fr = new FileReader();
    fr.onload = (ev) => setProfilePreview(ev.target.result);
    fr.readAsDataURL(file);
  };

  const handleShopFiles = (files) => {
    const arr = Array.from(files || []);

    for (const f of arr) {
      if (f.size / (1024 * 1024) > 1) {
        swal("Error", "Each shop photo must be ≤ 1MB", "error");
        return;
      }
    }

    setShopFiles(arr);

    const readers = arr.map(
      (f) =>
        new Promise((resolve) => {
          const fr = new FileReader();
          fr.onload = (ev) => resolve(ev.target.result);
          fr.readAsDataURL(f);
        }),
    );

    Promise.all(readers).then((imgs) => setShopPreviews(imgs));
  };

  const removeShopPreviewAt = (i) => {
    const src = shopPreviews?.[i] || "";

    setShopPreviews((prev) => prev.filter((_, idx) => idx !== i));

    if (String(src).startsWith("data:")) {
      setShopFiles((prev) => prev.filter((_, idx) => idx !== i));
      return;
    }

    try {
      const marker = "/Images/";
      const idx = String(src).indexOf(marker);

      if (idx !== -1) {
        const fn = String(src)
          .slice(idx + marker.length)
          .split("?")[0];

        if (fn) setRemovedShopPhotos((p) => [...p, fn]);
      }
    } catch {}
  };

  const applySalespersonByPincode = (pincode6, users) => {
    const filtered = getSalespeopleForPincode(pincode6, users);

    if (filtered.length) {
      setAutoAssign(true);
      setAssignDropdown(filtered);

      setSelectedSalesPerson((prev) => {
        if (prev && filtered.some((x) => x?._id === prev?._id)) return prev;
        return filtered[0];
      });

      setManualAssignOpen(false);

      setFormData((p) => ({
        ...p,
        _autoAssign: true,
        _assignDropdown: filtered,
        _selectedSalesPerson:
          p?._selectedSalesPerson &&
          filtered.some((x) => x?._id === p?._selectedSalesPerson?._id)
            ? p._selectedSalesPerson
            : filtered[0],
      }));
    } else {
      setAutoAssign(false);
      setAssignDropdown([]);
      setSelectedSalesPerson(null);
      setManualAssignOpen(true);

      setFormData((p) => ({
        ...p,
        _autoAssign: false,
        _assignDropdown: [],
        _selectedSalesPerson: null,
      }));
    }
  };

  const findSalespersonForCustomer = (customerData) => {
    if (customerData?._selectedSalesPerson?._id) {
      return customerData._selectedSalesPerson;
    }

    const pin = String(customerData?.pincode || "");
    const list = getSalespeopleForPincode(pin, allUsers);

    return list[0] || null;
  };

  useEffect(() => {
    if (!pendingAssignPincode) return;
    if (pendingAssignPincode.length !== 6) return;
    if (!Array.isArray(allUsers) || allUsers.length === 0) return;

    applySalespersonByPincode(pendingAssignPincode, allUsers);
    setPendingAssignPincode("");
  }, [allUsers, pendingAssignPincode]);

  const handlePincodeChange = async (raw) => {
    const onlyDigits = (raw || "").replace(/[^\d]/g, "");

    setFormData((p) => ({ ...p, pincode: onlyDigits }));

    if (onlyDigits.length !== 6) {
      setShowCityDropdown(false);
      setCityOptions([]);
      setAutoAssign(false);
      setAssignDropdown([]);
      setSelectedSalesPerson(null);
      setManualAssignOpen(false);
      setPendingAssignPincode("");

      setFormData((p) => ({
        ...p,
        City: "",
        State: "",
        transporterDetail: 0,
        assignTransporter: [],
        _autoAssign: false,
        _assignDropdown: [],
        _selectedSalesPerson: null,
      }));
      return;
    }

    if (!Array.isArray(allUsers) || allUsers.length === 0) {
      setPendingAssignPincode(onlyDigits);
      setManualAssignOpen(false);
    } else {
      applySalespersonByPincode(onlyDigits, allUsers);
    }

    const reqId = ++pinReqRef.current;
    setPincodeLoading(true);

    try {
      const url = `${viewpincodedata1}?pincode=${onlyDigits}`;
      const res = await _GetByUrlOnly(url);

      if (reqId !== pinReqRef.current) return;

      const list = Array.isArray(res?.pinCodes) ? res.pinCodes : [];

      if (res?.status && list.length) {
        const currentCity = toStr(formData?.City);

        const foundCurrent =
          list.find(
            (x) => toStr(x?.city).toLowerCase() === currentCity.toLowerCase(),
          ) || null;

        const selected = foundCurrent || list[0];

        const newCity = toStr(selected?.city);
        const newState = toStr(selected?.state);

        setCityOptions(list);
        setShowCityDropdown(list.length > 1);

        setFormData((p) => {
          const updated = {
            ...p,
            pincode: onlyDigits,
            City: newCity,
            State: newState,
            _cityOptions: list,
            _showCityDropdown: list.length > 1,
          };

          return applyTransporterByCityToData(updated, newCity);
        });

        return;
      }

      setShowCityDropdown(false);
      setCityOptions([]);

      setFormData((p) => ({
        ...p,
        City: "",
        State: "",
        transporterDetail: 0,
        assignTransporter: [],
      }));
    } catch {
      let match = pinCodeList.find((x) => String(x?.pincode) === onlyDigits);

      if (!match && Array.isArray(countryCityList) && countryCityList.length) {
        match =
          countryCityList.find((x) => String(x?.pincode) === onlyDigits) ||
          countryCityList.find((x) => String(x?.pinCode) === onlyDigits) ||
          null;
      }

      if (match) {
        const city =
          match.city || match.City || match.district || match.District || "";
        const state = match.state || match.State || "";

        setShowCityDropdown(false);
        setCityOptions([]);

        setFormData((p) => {
          const updated = {
            ...p,
            pincode: onlyDigits,
            City: city,
            State: state,
            _cityOptions: [],
            _showCityDropdown: false,
          };

          return applyTransporterByCityToData(updated, city);
        });
      } else {
        setShowCityDropdown(false);
        setCityOptions([]);

        setFormData((p) => ({
          ...p,
          City: "",
          State: "",
          transporterDetail: 0,
          assignTransporter: [],
        }));
      }
    } finally {
      if (reqId === pinReqRef.current) setPincodeLoading(false);
    }
  };

  const handleCitySelectFromDropdown = (cityName) => {
    const chosenCity = toStr(cityName);

    const found =
      (cityOptions || []).find((x) => toStr(x?.city) === chosenCity) || null;

    if (!found) {
      setFormData((p) =>
        applyTransporterByCityToData({ ...p, City: chosenCity }, chosenCity),
      );
      return;
    }

    setFormData((p) => {
      const updated = {
        ...p,
        City: toStr(found?.city),
        State: toStr(found?.state),
      };

      return applyTransporterByCityToData(updated, updated.City);
    });
  };

  const handleAutoAssignSelect = (e) => {
    const id = e.target.value || "";
    const sel = assignDropdown.find((p) => p?._id === id) || null;

    setSelectedSalesPerson(sel);

    setFormData((p) => ({
      ...p,
      _autoAssign: !!sel,
      _assignDropdown: assignDropdown,
      _selectedSalesPerson: sel,
    }));
  };

  const ensureTransporterListForCity = () => {
    if (!formData?.City) {
      return swal("Enter company pincode first to determine the city");
    }
  };

  const transporterOptions = useMemo(() => {
    const city = (formData?.City || "").toLowerCase().trim();

    if (!city) return allTransporter || [];

    const filtered = getTransportersForCity(city);

    return filtered.length ? filtered : allTransporter || [];
  }, [allTransporter, formData?.City]);

  const parseBulkFile = async () => {
    if (!bulkFile)
      return swal("Error", "Please choose Excel/CSV file", "error");

    try {
      setLoading(true);

      const rows = await readBulkFileRows(bulkFile);
      const validRows = rows.filter((r) => !isEmptyExcelRow(r));

      if (!validRows.length) {
        swal("Error", "No valid rows found in file", "error");
        return;
      }

      const baseForm = { ...formData };

      const normalizedRows = validRows.map((row, index) =>
        normalizeExcelCustomerRow(row, index, baseForm),
      );

      const hydratedRows = [];

      for (const item of normalizedRows) {
        const hydrated = await resolveCityStateByPincodeForData(item);
        hydratedRows.push(applySalespersonByPincodeToData(hydrated, allUsers));
      }

      const prepared = hydratedRows.map((data, index) => ({
        tempId: `${Date.now()}-${index}`,
        errorMessage: "",
        data,
      }));

      setBulkCustomers(prepared);
      setExpandedBulkIndex(0);
      setActiveBulkIndex(0);

      const first = prepared[0]?.data || makeDefaultCustomerForm();

      resetTransientRowStates();
      setFormData(first);
      setCityOptions(first?._cityOptions || []);
      setShowCityDropdown(Boolean(first?._showCityDropdown));
      setAssignStateFromData(first);

      swal(
        "File loaded",
        `${prepared.length} customer row(s) created. Click any card to open details.`,
        "success",
      );
    } catch (err) {
      console.log(err);
      swal(
        "Error",
        "Could not read this file. Please upload a valid .xlsx or .csv file.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const openBulkCustomer = (index) => {
    const item = bulkCustomers?.[index];
    if (!item) return;

    resetTransientRowStates();

    const nextOpen = expandedBulkIndex === index ? null : index;

    setExpandedBulkIndex(nextOpen);
    setActiveBulkIndex(index);

    const enhanced = applySalespersonByPincodeToData(
      item.data || makeDefaultCustomerForm(),
      allUsers,
    );

    setFormData(enhanced);
    setCityOptions(enhanced?._cityOptions || []);
    setShowCityDropdown(Boolean(enhanced?._showCityDropdown));
    setAssignStateFromData(enhanced);

    setBulkCustomers((prev) =>
      prev.map((x, i) => (i === index ? { ...x, data: enhanced } : x)),
    );
  };

  const removeBulkCustomer = (index, e) => {
    if (e) e.stopPropagation();

    setBulkCustomers((prev) => {
      const next = prev.filter((_, i) => i !== index);

      if (!next.length) {
        setExpandedBulkIndex(null);
        setActiveBulkIndex(-1);
        setFormData(makeDefaultCustomerForm());
        resetTransientRowStates();
        return next;
      }

      const newIndex = Math.min(index, next.length - 1);

      setExpandedBulkIndex(newIndex);
      setActiveBulkIndex(newIndex);

      const nextData = applySalespersonByPincodeToData(
        next[newIndex]?.data || makeDefaultCustomerForm(),
        allUsers,
      );

      resetTransientRowStates();
      setFormData(nextData);
      setCityOptions(nextData?._cityOptions || []);
      setShowCityDropdown(Boolean(nextData?._showCityDropdown));
      setAssignStateFromData(nextData);

      next[newIndex] = { ...next[newIndex], data: nextData };

      return next;
    });
  };

  const buildCustomerFormData = (customerData, options = {}) => {
    const { includeCurrentFiles = true } = options;

    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const fd = new FormData();

    const fixedRegion = ["Local", "Outside"].includes(customerData?.regionType)
      ? customerData.regionType
      : inferRegionType(getSuperGST(), customerData?.gstNumber || "");

    const effectiveId =
      customerData?.id ||
      customerData?.comPanNo ||
      customerData?.aadharNo ||
      customerData?.gstNumber ||
      `${customerData?.CompanyName || "CUSTOMER"}-${Date.now()}`;

    const toSend = {
      ...customerData,
      id: effectiveId,
      regionType: fixedRegion || "Local",
      openingFinancialYear: normalizeOpeningFinancialYear(
        customerData?.openingFinancialYear || getCurrentOpeningFinancialYear(),
      ),
    };

    delete toSend?.assignTransporter;
    delete toSend?.shopPhotos;
    delete toSend?.database;
    delete toSend?._bulkRowNo;
    delete toSend?._cityOptions;
    delete toSend?._showCityDropdown;
    delete toSend?._autoAssign;
    delete toSend?._assignDropdown;
    delete toSend?._selectedSalesPerson;
    delete toSend?.errorMessage;
    delete toSend?.savedId;
    delete toSend?.tempId;

    if (!toSend?.created_by && user?._id) {
      toSend.created_by = user._id;
    }

    Object.entries(toSend).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      if (v === "") return;

      if (Array.isArray(v)) {
        if (v.length) fd.append(k, JSON.stringify(v));
      } else if (typeof v === "object") {
        fd.append(k, JSON.stringify(v));
      } else {
        fd.append(k, v);
      }
    });

    if (includeCurrentFiles) {
      if (profileFile) fd.append("file", profileFile);
      if (shopFiles?.length) shopFiles.forEach((f) => fd.append("files", f));
    }

    if (
      Array.isArray(customerData?.assignTransporter) &&
      customerData.assignTransporter.length
    ) {
      fd.append(
        "assignTransporter",
        JSON.stringify(customerData.assignTransporter),
      );
    }

    if (user?.database) fd.append("database", user.database);

    return fd;
  };

  const saveCustomerData = async (customerData, options = {}) => {
    const {
      includeCurrentFiles = true,
      explicitParentId = "",
      shouldNavigate = false,
    } = options;

    const fd = buildCustomerFormData(customerData, { includeCurrentFiles });

    const res = await CreateCustomersave(fd);

    if (res?.status) {
      const newId = res?.Customer?._id;
      const autoSalesperson = findSalespersonForCustomer(customerData);

      const parentId =
        explicitParentId ||
        (autoSalesperson && autoSalesperson?._id ? autoSalesperson._id : "");

      if (newId && parentId) {
        const payload = {
          parentId,
          childs: [{ id: newId }],
        };

        await _PostSave(User_Assign_User, payload).catch(() => {});
      }

      if (shouldNavigate) {
        swal("Customer created successfully");
        navigate(-1);
      }

      return res;
    }

    throw new Error(res?.message || "Customer could not be saved");
  };

  const clearSavedBulkRow = (index) => {
    setBulkCustomers((prev) => {
      const next = prev.filter((_, i) => i !== index);

      if (!next.length) {
        setExpandedBulkIndex(null);
        setActiveBulkIndex(-1);
        resetTransientRowStates();
        setFormData(makeDefaultCustomerForm());
        return next;
      }

      const newIndex = Math.min(index, next.length - 1);

      setExpandedBulkIndex(newIndex);
      setActiveBulkIndex(newIndex);

      const nextData = applySalespersonByPincodeToData(
        next[newIndex]?.data || makeDefaultCustomerForm(),
        allUsers,
      );

      resetTransientRowStates();
      setFormData(nextData);
      setCityOptions(nextData?._cityOptions || []);
      setShowCityDropdown(Boolean(nextData?._showCityDropdown));
      setAssignStateFromData(nextData);

      next[newIndex] = { ...next[newIndex], data: nextData };

      return next;
    });
  };

  const handleSaveBulkCustomer = async (index) => {
    const item = bulkCustomers?.[index];
    if (!item) return;

    const dataToSave =
      activeBulkIndex === index
        ? {
            ...formData,
            _autoAssign: autoAssign,
            _assignDropdown: assignDropdown,
            _selectedSalesPerson: selectedSalesPerson,
          }
        : { ...(item.data || {}) };

    try {
      setBulkSavingIndex(index);

      const explicitParentId =
        assignedTo ||
        selectedSalesPerson?._id ||
        dataToSave?._selectedSalesPerson?._id ||
        "";

      await saveCustomerData(dataToSave, {
        includeCurrentFiles: activeBulkIndex === index,
        explicitParentId,
        shouldNavigate: false,
      });

      clearSavedBulkRow(index);

      swal("Saved", "Customer saved successfully", "success");
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || "Customer save failed";

      setBulkCustomers((prev) =>
        prev.map((x, i) =>
          i === index
            ? {
                ...x,
                data: dataToSave,
                errorMessage: msg,
              }
            : x,
        ),
      );

      swal("Error", msg, "error");
    } finally {
      setBulkSavingIndex(null);
    }
  };

  const handleSaveAllBulkCustomers = async () => {
    if (!bulkCustomers.length) return;

    const ok = await swal({
      title: "Save all customers?",
      text: `${bulkCustomers.length} customer(s) will be created now. Saved rows will be removed. Failed rows will remain.`,
      icon: "warning",
      buttons: ["Cancel", "Save All"],
    });

    if (!ok) return;

    setBulkSaveAllLoading(true);

    let success = 0;
    let failed = 0;
    const failedRows = [];

    for (let index = 0; index < bulkCustomers.length; index++) {
      const item = bulkCustomers[index];

      try {
        const dataToSave =
          activeBulkIndex === index
            ? {
                ...formData,
                _autoAssign: autoAssign,
                _assignDropdown: assignDropdown,
                _selectedSalesPerson: selectedSalesPerson,
              }
            : { ...(item.data || {}) };

        await saveCustomerData(dataToSave, {
          includeCurrentFiles: false,
          explicitParentId:
            dataToSave?._selectedSalesPerson?._id ||
            findSalespersonForCustomer(dataToSave)?._id ||
            "",
          shouldNavigate: false,
        });

        success += 1;
      } catch (err) {
        failed += 1;

        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Customer save failed";

        failedRows.push({
          ...item,
          data: activeBulkIndex === index ? { ...formData } : item.data,
          errorMessage: msg,
        });
      }
    }

    setBulkCustomers(failedRows);

    if (failedRows.length) {
      setExpandedBulkIndex(0);
      setActiveBulkIndex(0);

      const first = applySalespersonByPincodeToData(
        failedRows[0]?.data || makeDefaultCustomerForm(),
        allUsers,
      );

      resetTransientRowStates();
      setFormData(first);
      setCityOptions(first?._cityOptions || []);
      setShowCityDropdown(Boolean(first?._showCityDropdown));
      setAssignStateFromData(first);
    } else {
      setExpandedBulkIndex(null);
      setActiveBulkIndex(-1);
      resetTransientRowStates();
      setFormData(makeDefaultCustomerForm());
    }

    setBulkSaveAllLoading(false);

    swal(
      "Bulk Save Completed",
      `Saved: ${success}\nFailed: ${failed}`,
      failed ? "warning" : "success",
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (bulkMode) {
      if (activeBulkIndex >= 0) {
        await handleSaveBulkCustomer(activeBulkIndex);
      }
      return;
    }

    try {
      setLoading(true);

      if (!["Local", "Outside"].includes(formData?.regionType)) {
        const superGST = getSuperGST();
        const inferred = inferRegionType(superGST, formData?.gstNumber || "");
        setFormData((p) => ({ ...p, regionType: inferred || "Local" }));
      }

      if (isCreate) {
        await saveCustomerData(formData, {
          includeCurrentFiles: true,
          explicitParentId:
            assignedTo ||
            selectedSalesPerson?._id ||
            formData?._selectedSalesPerson?._id ||
            "",
          shouldNavigate: true,
        });
      } else {
        // When this page is opened from a conversion request, SuperAdmin is
        // editing the SAME lead/customer document before approval. Never let
        // this edit activate it or bypass OTP + approval.
        const dataToUpdate = isConversionEdit
          ? {
              ...formData,
              status: "Deactive",
              leadStatusCheck: "true",
              conversionStatus: "Waiting",
            }
          : formData;

        const fd = buildCustomerFormData(dataToUpdate, {
          includeCurrentFiles: true,
        });

        const res = await CreateCustomerUpdate(Params?.id, fd);

        if (res?.status) {
          // Persist the selected salesperson through the same assignment API
          // used by AssignTeamMember.jsx.
          const selectedParentId =
            selectedSalesPerson?._id ||
            formData?._selectedSalesPerson?._id ||
            "";

          if (selectedParentId && Params?.id) {
            await _PostSave(User_Assign_User, {
              parentId: selectedParentId,
              childs: [{ id: Params.id }],
            }).catch(() => {});
          }

          if (isConversionEdit) {
            try {
              sessionStorage.setItem("SalesLeadReturnTab", "requested");
            } catch {}

            await swal(
              "Conversion Details Updated",
              "The conversion details were updated. The record is still Deactive and Waiting for SuperAdmin approval.",
              "success",
            );
            navigate(-1);
          } else {
            swal("Customer Updated Successfully");
            navigate(-1);
          }
        }
      }
    } catch (err) {
      swal("error", err?.response?.data?.message || "Error Occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (String(id) === "0") {
      return swal("Info", "Cannot delete in Create mode", "info");
    }

    const choice = await swal("Warning", "Sure you want to delete it?", {
      buttons: { cancel: "Cancel", catch: { text: "Delete", value: "delete" } },
    });

    if (choice === "delete") {
      try {
        await DeleteCustomerList(id);
        navigate(-1);
      } catch {
        swal("Error", "Could not delete customer", "error");
      }
    }
  };

  const departmentOptions = useMemo(() => {
    const list = Array.isArray(deptWithRole) ? deptWithRole : [];

    return list.map((d) => {
      const id = d?._id || d?.id || "";

      const name =
        safeText(d?.departmentName) ||
        safeText(d?.DepartmentName) ||
        safeText(d?.deptName) ||
        safeText(d?.name) ||
        safeText(d?.department) ||
        safeText(d?._id) ||
        "Department";

      const roles =
        d?.roles || d?.Roles || d?.role || d?.Role || d?.roleList || [];

      return { _id: id, name, roles };
    });
  }, [deptWithRole]);

  const roleOptionsForDept = useMemo(() => {
    if (!selectedDept) return [];

    const dep = departmentOptions.find((d) => d._id === selectedDept);
    const rawRoles = dep?.roles || [];
    const roles = Array.isArray(rawRoles) ? rawRoles : [];

    return roles
      .map((r) => {
        if (typeof r === "string") return { _id: r, roleName: r };

        return {
          _id: r?._id || r?.id || r?.roleId || "",
          roleName:
            safeText(r?.roleName) ||
            safeText(r?.RoleName) ||
            safeText(r?.name) ||
            safeText(r?.title) ||
            "Role",
        };
      })
      .filter((r) => r._id || r.roleName);
  }, [departmentOptions, selectedDept]);

  useEffect(() => {
    if (!selectedDept) {
      setSelectedRole("");
      return;
    }

    setSelectedRole("");
  }, [selectedDept]);

  const manualAssignableUsers = useMemo(() => {
    const list = Array.isArray(allUsers) ? allUsers : [];

    let filtered = list.filter(
      (u) => u?.rolename?.roleName && u.rolename.roleName !== "Customer",
    );

    if (selectedRole) {
      filtered = filtered.filter((u) => {
        const rn = u?.rolename;
        const rid = rn?._id || rn?.id || rn;
        const rname = rn?.roleName || rn?.name || "";

        return (
          String(rid) === String(selectedRole) ||
          String(rname) === String(selectedRole)
        );
      });
    }

    return filtered;
  }, [allUsers, selectedRole]);

  const handleBack = () => {
    if (isConversionEdit) {
      try {
        sessionStorage.setItem("SalesLeadReturnTab", "requested");
      } catch {}
    }
    navigate(-1);
  };

  const HeaderCard = (
    <Card className="cc-card" style={{ marginBottom: 12 }}>
      <Row className="m-2">
        <Col lg="4" md="4">
          <div className="cc-h1">
            {isConversionEdit
              ? "Edit Conversion Customer"
              : `${isCreate ? "Create" : "Edit"} Customer`}
          </div>
        </Col>

        <Col />

        {isCreate && (
          <Col lg="2" md="2">
            <div className="d-flex justify-content-end">
              {!bulkMode ? (
                <Button
                  color="primary"
                  style={{ width: "12rem" }}
                  onClick={() => setBulkMode(true)}
                >
                  Bulk Upload
                </Button>
              ) : (
                <Button
                  color="primary"
                  style={{ width: "8rem" }}
                  onClick={() => {
                    setBulkMode(false);
                    setBulkCustomers([]);
                    setExpandedBulkIndex(null);
                    setActiveBulkIndex(-1);
                    resetTransientRowStates();
                    setFormData(makeDefaultCustomerForm());
                  }}
                >
                  Back
                </Button>
              )}
            </div>
          </Col>
        )}

        {!bulkMode && !isConversionEdit && (
          <Button
            color="primary"
            style={{ width: "12rem" }}
            onClick={() => handleDelete(Params?.id)}
          >
            Delete
          </Button>
        )}

        <Col lg="2" md="2">
          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              style={{ width: "10rem" }}
              onClick={handleBack}
            >
              Back
            </Button>
          </div>
        </Col>
      </Row>
    </Card>
  );

  const CompanyInfoCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Company Information</div>
      </div>

      <Row>
        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Company Name <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              required
              name="CompanyName"
              placeholder="Enter Company Name"
              value={formData?.CompanyName || ""}
              onChange={handleInput}
            />
          </FormGroup>
        </Col>

        {formData?.registrationType !== "UnRegister" && (
          <Col lg="6" md="6" sm="12">
            <FormGroup>
              <Label>
                GST Number <span style={{ color: "red" }}>*</span>
              </Label>
              <Input
                required
                name="gstNumber"
                placeholder="Enter Correct GST Number"
                value={formData?.gstNumber || ""}
                maxLength={15}
                onChange={(e) => handleGSTChange(e.target.value)}
              />
              {loading && loaderText && (
                <div style={{ color: "red", fontSize: 12 }}>{loaderText}</div>
              )}
            </FormGroup>
          </Col>
        )}

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Region Type <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="select"
              name="regionType"
              value={formData?.regionType || "Local"}
              onChange={handleRegionTypeChange}
            >
              <option value="Local">Local</option>
              <option value="Outside">Outside</option>
            </Input>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Party Type</Label>
            <Input
              type="select"
              name="partyType"
              value={formData?.partyType || "N/A"}
              onChange={handleInput}
            >
              <option value="N/A">-- Select --</option>
              <option value="eCommerce">E-Commerce</option>
              <option value="Debitor">Debitor</option>
              <option value="Creditor">Creditor</option>
            </Input>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Registration Type</Label>
            <Input
              type="select"
              name="registrationType"
              value={formData?.registrationType || "UnKnown"}
              onChange={handleInput}
            >
              <option value="UnKnown">UnKnown</option>
              <option value="Regular">Regular</option>
              <option value="UnRegister">UnRegister</option>
            </Input>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Company PAN <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              required
              name="comPanNo"
              placeholder="Enter Company PAN"
              value={formData?.comPanNo || ""}
              maxLength={10}
              onChange={(e) => {
                const up = (e.target.value || "").toUpperCase();
                setFormData((p) => ({ ...p, comPanNo: up }));
                if (up.length === 10) verifyCompanyPAN(up);
              }}
            />
            {formData?.comPanNo && formData?.IsValid_comPanNo === true && (
              <div style={{ color: "green", fontSize: 12 }}>Verified</div>
            )}
            {formData?.comPanNo && formData?.IsValid_comPanNo === false && (
              <div style={{ color: "red", fontSize: 12 }}>
                PAN not verified with GST
              </div>
            )}
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Aadhar Number <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              required
              name="aadharNo"
              placeholder="Enter Aadhar Number"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={12}
              value={formData?.aadharNo || ""}
              onChange={(e) => {
                const v = e.target.value.replace(/[^\d]/g, "");
                const ok = /^\d{12}$/.test(v);

                setFormData((p) => ({
                  ...p,
                  aadharNo: v,
                  IsValid_Aadhar_No: ok,
                }));
              }}
            />
            {formData?.aadharNo && !formData?.IsValid_Aadhar_No && (
              <div style={{ color: "red", fontSize: 12 }}>
                Enter correct Aadhar No
              </div>
            )}
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Mobile Number</Label>
            <PhoneInput
              inputClass="myphoneinput"
              country="in"
              countryCodeEditable={false}
              value={String(formData?.mobileNumber || "")}
              onChange={(phone) =>
                setFormData((p) => ({ ...p, mobileNumber: Number(phone) }))
              }
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Address <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              required
              name="address"
              placeholder="Registered address"
              value={formData?.address || ""}
              onChange={handleInput}
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Deals in Product</Label>
            <Input
              name="dealsInProducts"
              placeholder="Products / Categories"
              value={formData?.dealsInProducts || ""}
              onChange={handleInput}
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Annual Turnover</Label>
            <Input
              name="annualTurnover"
              type="number"
              placeholder="e.g. 500000"
              value={formData?.annualTurnover || ""}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  annualTurnover: Number(e.target.value || 0),
                }))
              }
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Shop Size</Label>
            <Input
              name="shopSize"
              placeholder="e.g. 120x100"
              value={formData?.shopSize || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, shopSize: e.target.value }))
              }
            />
          </FormGroup>
        </Col>

        <Col sm="12" className="mt-1">
          <div className="cc-sub" style={{ textAlign: "center" }}>
            Bank Accounts
          </div>

          {(Array.isArray(formData.bankDetails) && formData.bankDetails.length
            ? formData.bankDetails
            : [{ Account_Name: "", Account_No: "", Ifsc_code: "" }]
          ).map((b, idx) => (
            <Row key={idx} style={{ alignItems: "flex-end" }}>
              <Col lg="5" md="5" sm="12">
                <FormGroup>
                  <Label>Bank Name</Label>
                  <Input
                    name="Account_Name"
                    placeholder="Bank / Account Name"
                    value={b.Account_Name || ""}
                    onChange={(e) => handleInput(e, "text", idx)}
                  />
                </FormGroup>
              </Col>

              <Col lg="4" md="5" sm="12">
                <FormGroup>
                  <Label>Account Number</Label>
                  <Input
                    name="Account_No"
                    placeholder="Account Number"
                    value={b.Account_No || ""}
                    onChange={(e) => handleInput(e, "text", idx)}
                  />
                </FormGroup>
              </Col>

              <Col lg="3" md="2" sm="12">
                <FormGroup>
                  <Label>IFSC</Label>
                  <Input
                    name="Ifsc_code"
                    placeholder="IFSC Code"
                    value={b.Ifsc_code || ""}
                    onChange={(e) => handleInput(e, "text", idx)}
                  />
                </FormGroup>
              </Col>

              {idx !== 0 && (
                <Col sm="12">
                  <span
                    style={{ cursor: "pointer", color: "red" }}
                    onClick={() => removeBank(idx)}
                  >
                    <MdDelete size={22} /> remove account
                  </span>
                </Col>
              )}
            </Row>
          ))}

          <div className="d-flex justify-content-end">
            <Button color="primary" onClick={addBank}>
              Add Another Account
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );

  const LocationCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Location</div>
      </div>

      <Row>
        <Col lg="4" md="6" sm="12">
          <FormGroup>
            <Label>Pin Code</Label>
            <Input
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              placeholder="6-digit PIN"
              value={formData?.pincode || ""}
              onChange={(e) => handlePincodeChange(e.target.value)}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {pincodeLoading && (
              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                Finding city...
              </div>
            )}
          </FormGroup>
        </Col>

        <Col lg="4" md="6" sm="12">
          <FormGroup>
            <Label>City</Label>

            {showCityDropdown ? (
              <>
                <Input
                  className="cc-select"
                  type="select"
                  value={formData?.City || ""}
                  onChange={(e) => handleCitySelectFromDropdown(e.target.value)}
                >
                  {(cityOptions || []).map((c) => {
                    const city = toStr(c?.city);
                    const district = toStr(c?.district);
                    const label = district ? `${city} — ${district}` : city;
                    const key =
                      c?._id || `${toStr(c?.pincode)}-${city}-${district}`;

                    return (
                      <option key={key} value={city}>
                        {label}
                      </option>
                    );
                  })}
                </Input>

                <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
                  Multiple cities found. First city is auto-selected, you can
                  change it.
                </div>
              </>
            ) : (
              <Input readOnly value={formData?.City || ""} />
            )}
          </FormGroup>
        </Col>

        <Col lg="4" md="6" sm="12">
          <FormGroup>
            <Label>State</Label>
            <Input readOnly value={formData?.State || ""} />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );

  // const ImagesCard = (
  //   <div className="cc-section">
  //     <div className="d-flex justify-content-center">
  //       <div className="cc-sub">Images</div>
  //     </div>

  //     <Row>
  //       <Col lg="6" md="6" sm="12">
  //         <div className="d-flex justify-content-center">
  //           <Label>Owner/ID Image</Label>
  //         </div>

  //         <div className="cc-file">
  //           <FaUpload size={32} />
  //           <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
  //             Max file size 1 MB
  //           </div>
  //           <input
  //             type="file"
  //             onChange={(e) => handleProfileFile(e.target.files?.[0] || null)}
  //             style={{ marginTop: 8 }}
  //           />
  //         </div>

  //         {!!profilePreview && (
  //           <div className="mt-2">
  //             <img
  //               src={profilePreview}
  //               alt="profile"
  //               width={140}
  //               height={120}
  //               style={{ borderRadius: 8 }}
  //             />
  //           </div>
  //         )}
  //       </Col>

  //       <Col lg="6" md="6" sm="12">
  //         <div className="d-flex justify-content-center">
  //           <Label>Shop Photos</Label>
  //         </div>

  //         <div className="cc-file">
  //           <FaUpload size={32} />
  //           <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
  //             Multiple files, each ≤ 1 MB
  //           </div>
  //           <input
  //             type="file"
  //             multiple
  //             onChange={(e) => handleShopFiles(e.target.files)}
  //             style={{ marginTop: 8 }}
  //           />
  //         </div>

  //         <Row className="mt-2">
  //           {shopPreviews.map((src, i) => (
  //             <Col key={i} lg="6" md="6" sm="6" className="mb-2">
  //               <div style={{ position: "relative" }}>
  //                 <span
  //                   onClick={() => removeShopPreviewAt(i)}
  //                   style={{
  //                     cursor: "pointer",
  //                     position: "absolute",
  //                     right: 8,
  //                     top: 6,
  //                     color: "red",
  //                     zIndex: 2,
  //                   }}
  //                 >
  //                   <MdCancel size={22} />
  //                 </span>

  //                 <img
  //                   src={src}
  //                   alt="shop"
  //                   height={120}
  //                   width="100%"
  //                   style={{ borderRadius: 8 }}
  //                 />
  //               </div>
  //             </Col>
  //           ))}
  //         </Row>
  //       </Col>
  //     </Row>
  //   </div>
  // );

  const AssignMemberCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Assign Member</div>
      </div>

      <Row>
        <Col sm="12" className="d-flex flex-column align-items-center">
          <Label style={{ fontWeight: 700, marginBottom: 8 }}>
            Select Salesperson
          </Label>

          <Input
            style={{ width: 320, maxWidth: "100%" }}
            type="select"
            value={selectedSalesPerson?._id || ""}
            onChange={handleAutoAssignSelect}
            disabled={
              String(formData?.pincode || "").length !== 6 ||
              assignDropdown.length === 0
            }
          >
            <option value="">
              {String(formData?.pincode || "").length !== 6
                ? "-- Enter 6-digit pincode first --"
                : assignDropdown.length === 0
                  ? "-- No salesperson found for this pincode --"
                  : "-- Select Salesperson --"}
            </option>

            {assignDropdown.map((person) => (
              <option key={person?._id} value={person?._id}>
                {person?.firstName}{" "}
                {person?.lastName ? `(${person.lastName})` : ""}
              </option>
            ))}
          </Input>

          {String(formData?.pincode || "").length === 6 &&
            assignDropdown.length === 0 && (
              <div
                className="text-center mt-2"
                style={{ fontSize: 12, color: "#6b7280" }}
              >
                No active salesperson is assigned to this pincode.
              </div>
            )}
        </Col>
      </Row>
    </div>
  );

  const PaymentStatusCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Payment & Status</div>
      </div>

      <Row>
        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Payment Term <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              required
              id="paymentTerm"
              type="select"
              name="paymentTerm"
              value={formData?.paymentTerm || "N/A"}
              onChange={(e) =>
                setFormData((p) => ({ ...p, paymentTerm: e.target.value }))
              }
            >
              <option value="N/A">-- Select --</option>
              <option value="cash">Cash</option>
              <option value="credit">Credit</option>
            </Input>
          </FormGroup>
        </Col>

        {formData?.paymentTerm === "credit" && (
          <>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>
                  Credit Period (days) <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="number"
                  placeholder="e.g. 30"
                  value={formData?.lockInTime || ""}
                  onChange={(e) =>
                    setFormData((p) => ({
                      ...p,
                      lockInTime: Number(e.target.value || 0),
                    }))
                  }
                  required
                />
              </FormGroup>
            </Col>

            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>
                  Amount Limit <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="number"
                  placeholder="e.g. 500000"
                  value={formData?.limit || ""}
                  onChange={(e) =>
                    setFormData((p) => ({
                      ...p,
                      limit: Number(e.target.value || 0),
                    }))
                  }
                  required
                />
              </FormGroup>
            </Col>
          </>
        )}

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Status</Label>
            <div
              onChange={(e) =>
                setFormData((p) => ({ ...p, status: e.target.value }))
              }
            >
              <label className="mr-2">
                <input
                  type="radio"
                  name="status"
                  value="Active"
                  checked={formData?.status === "Active"}
                />{" "}
                Active
              </label>

              <label>
                <input
                  type="radio"
                  name="status"
                  value="Deactive"
                  checked={formData?.status === "Deactive"}
                />{" "}
                Deactive
              </label>
            </div>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Category</Label>
            <Input
              type="select"
              name="category"
              value={formData?.category || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, category: e.target.value }))
              }
              id="category"
            >
              <option value="">-- Select Category --</option>
              {customerGroups.map((g) => (
                <option key={g._id} value={g._id}>
                  {g.groupName} — Discount: {g.discount} — Grade: {g.grade}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </div>
  );

  const TransporterCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Transport</div>
      </div>

      <Row>
        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Assigned Transport</Label>
            <Input
              type="select"
              name="transporterDetail"
              value={formData?.transporterDetail ?? 0}
              onChange={(e) => {
                const v = Number(e.target.value);

                if (v === 1) {
                  if (!formData?.City) {
                    ensureTransporterListForCity();
                    setFormData((p) => ({ ...p, transporterDetail: 0 }));
                    return;
                  }
                }

                setFormData((p) => ({ ...p, transporterDetail: v }));
              }}
              id="transporterDetail"
            >
              <option value={0}>Local</option>
              <option value={1}>Assign Transporter</option>
            </Input>
          </FormGroup>
        </Col>

        {Number(formData?.transporterDetail) === 1 && (
          <Col lg="6" md="6" sm="12">
            <FormGroup>
              <Label>Transporter List</Label>
              <Multiselect
                isObject={true}
                options={transporterOptions}
                selectedValues={formData?.assignTransporter || []}
                onSelect={(list) =>
                  setFormData((p) => ({ ...p, assignTransporter: list }))
                }
                onRemove={(list) =>
                  setFormData((p) => ({ ...p, assignTransporter: list }))
                }
                displayValue="companyName"
              />
            </FormGroup>
          </Col>
        )}
      </Row>
    </div>
  );

  const OwnerMiscCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center">
        <div className="cc-sub">Owner & Misc</div>
      </div>

      <Row>
        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Owner Name</Label>
            <Input
              name="ownerName"
              placeholder="Owner name"
              value={formData?.ownerName || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, ownerName: e.target.value }))
              }
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Owner Number <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              placeholder="Owner phone"
              value={formData?.contactNumber || ""}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  contactNumber: Number(e.target.value || 0),
                }))
              }
              required
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Owner Address</Label>
            <Input
              name="ownerAddress"
              placeholder="Owner address"
              value={formData?.ownerAddress || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, ownerAddress: e.target.value }))
              }
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Service Area</Label>
            <Input
              type="textarea"
              rows={3}
              name="serviceArea"
              placeholder="Service area"
              value={formData?.serviceArea || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, serviceArea: e.target.value }))
              }
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Opening Financial Year</Label>
            <Input
              type="select"
              name="openingFinancialYear"
              value={
                formData?.openingFinancialYear ||
                getCurrentOpeningFinancialYear()
              }
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  openingFinancialYear: normalizeOpeningFinancialYear(
                    e.target.value,
                  ),
                }))
              }
            >
              {openingFYOptions.map((fy) => (
                <option key={fy} value={fy}>
                  {fy}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Opening Balance</Label>
            <Input
              type="number"
              name="OpeningBalance"
              placeholder="Opening balance"
              value={formData?.OpeningBalance || ""}
              onChange={(e) =>
                setFormData((p) => ({
                  ...p,
                  OpeningBalance: Number(e.target.value || 0),
                }))
              }
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>O/P Balance Type</Label>
            <Input
              type="select"
              id="balanceType"
              name="Type"
              value={formData?.Type || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, Type: e.target.value }))
              }
            >
              <option value="">-- Select Type --</option>
              <option value="debit">Dr</option>
              <option value="credit">Cr</option>
            </Input>
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Email <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="email"
              name="email"
              placeholder="Email"
              value={formData?.email || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, email: e.target.value }))
              }
              required
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>
              Password <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="password"
              name="password"
              placeholder="Password"
              value={formData?.password || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, password: e.target.value }))
              }
              required
            />
          </FormGroup>
        </Col>

        <Col lg="6" md="6" sm="12">
          <FormGroup>
            <Label>Geotagging</Label>
            <Input
              name="geotagging"
              placeholder="lat,long"
              value={formData?.geotagging || ""}
              onChange={(e) =>
                setFormData((p) => ({ ...p, geotagging: e.target.value }))
              }
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );

  const CustomerFormGrid = (
    <div className="cc-grid-2">
      <div className="cc-col">
        {CompanyInfoCard}
        {LocationCard}
        {/* {ImagesCard} */}
      </div>

      <div className="cc-col">
        {AssignMemberCard}
        {PaymentStatusCard}
        {TransporterCard}
        {OwnerMiscCard}
      </div>
    </div>
  );

  const BulkUploadCard = (
    <div className="cc-section">
      <div className="d-flex justify-content-center mb-2">
        <div className="cc-sub">Bulk Upload Preview</div>
      </div>

      <Row>
        <Col className="d-flex justify-content-center">
          <div className="cc-file" style={{ width: 480 }}>
            <FaUpload size={40} />

            <div style={{ marginTop: 8, fontWeight: 700 }}>
              Upload Excel / CSV Template
            </div>

            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
              Supported fields: OpeningBalance, openingFinancialYear, Type,
              pincode, CompanyName, comPanNo
            </div>

            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              style={{ marginTop: 10 }}
              onChange={(e) => setBulkFile(e.target.files?.[0] || null)}
            />

            <Button
              color="primary"
              className="mt-3"
              onClick={parseBulkFile}
              disabled={loading}
            >
              {loading ? "Reading File..." : "Load File"}
            </Button>
          </div>
        </Col>
      </Row>

      {bulkCustomers.length > 0 && (
        <>
          <Row className="mt-3">
            <Col className="d-flex justify-content-between align-items-center">
              <div style={{ fontWeight: 700 }}>
                Unsaved Customers: {bulkCustomers.length}
              </div>

              <Button
                color="primary"
                onClick={handleSaveAllBulkCustomers}
                disabled={bulkSaveAllLoading || loading}
              >
                {bulkSaveAllLoading ? "Saving All..." : "Save All"}
              </Button>
            </Col>
          </Row>

          <div className="mt-3">
            {bulkCustomers.map((item, index) => {
              const data = item?.data || {};
              const isOpen = expandedBulkIndex === index;

              return (
                <div className="cc-bulk-simple-card" key={item.tempId || index}>
                  <div
                    className="cc-bulk-simple-head"
                    onClick={() => openBulkCustomer(index)}
                  >
                    <div>
                      <div className="cc-bulk-simple-title">
                        {data?.CompanyName || `Customer Row ${index + 1}`} -{" "}
                        {data?.comPanNo || "-"}
                      </div>

                      {item?.errorMessage && (
                        <div className="cc-bulk-error">{item.errorMessage}</div>
                      )}
                    </div>

                    <button
                      type="button"
                      className="cc-bulk-cross"
                      onClick={(e) => removeBulkCustomer(index, e)}
                    >
                      ×
                    </button>
                  </div>

                  {isOpen && (
                    <div className="cc-bulk-simple-body">
                      {CustomerFormGrid}

                      <div className="d-flex justify-content-center mt-3">
                        <Button
                          color="primary"
                          onClick={() => handleSaveBulkCustomer(index)}
                          disabled={bulkSavingIndex === index}
                          style={{ minWidth: 180 }}
                        >
                          {bulkSavingIndex === index
                            ? "Saving..."
                            : "Save This Customer"}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );

  return (
    <div className="cc-wrap">
      {HeaderCard}

      <Card className="cc-card">
        <CardBody>
          {bulkMode ? BulkUploadCard : CustomerFormGrid}

          {!bulkMode && (
            <div className="d-flex justify-content-center mt-3">
              {loading ? (
                <Spinner />
              ) : (
                <Button
                  color="primary"
                  onClick={(e) => handleSubmit(e)}
                  style={{ minWidth: 160 }}
                >
                  {isCreate
                    ? "Submit"
                    : isConversionEdit
                      ? "Update Conversion Details"
                      : "Update"}
                </Button>
              )}
            </div>
          )}
        </CardBody>
      </Card>

      <Modal
        isOpen={manualAssignOpen}
        toggle={() => setManualAssignOpen(false)}
        size="md"
      >
        <ModalHeader toggle={() => setManualAssignOpen(false)}>
          No Salesperson Found
        </ModalHeader>

        <ModalBody>
          <p>
            No salesperson is assigned to this pincode yet. Do you want to go to
            the Salesperson Assignment Page?
          </p>

          <div className="d-flex justify-content-end">
            <Button
              color="secondary"
              onClick={() => setManualAssignOpen(false)}
            >
              Cancel
            </Button>

            <Button
              color="primary"
              className="ms-2"
              onClick={() => {
                setManualAssignOpen(false);
                navigate("/app/assign-pincode");
              }}
            >
              Go to Assign Page
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateCustomerTwoColumnHybrid;
